import { render, staticRenderFns } from "./DealTicketsReport.vue?vue&type=template&id=1f858ecc&"
import script from "./DealTicketsReport.vue?vue&type=script&lang=js&"
export * from "./DealTicketsReport.vue?vue&type=script&lang=js&"
import style0 from "./DealTicketsReport.vue?vue&type=style&index=0&id=1f858ecc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports